module.exports = __webpack_public_path__ + "img/marker_start.d114ff08.png";